import FuelLevel from "@hydrologiq/shared/monitoring/figures/FuelLevel"
import { EnergyUnit } from "@hydrologiq/common/types/energy/consumption"
import { DateTime } from "timezonecomplete"
import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface HydrogenLevelFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function HydrogenLevelFigure({ data, loading, error, isPlaceholder, compact = isCompactFigure("summary") }: HydrogenLevelFigureProps) {
  const currentLevel = data?.value ?? null
  const maxLevel = data?.metadata?.maxLevel ?? data?.value
  const offset = data?.metadata?.offset
  const minWeight = data?.metadata?.minWeight
  const refuellingTime = data?.metadata?.refuellingTime ? new DateTime(data?.metadata.refuellingTime) : null

  // Convert unit string to EnergyUnit enum
  const unit = (data?.unit?.toLowerCase() === "kg" ? EnergyUnit.kg : EnergyUnit.kg) as EnergyUnit

  return (
    <FuelLevel
      currentLevel={currentLevel}
      maxLevel={maxLevel}
      offset={offset}
      heading={data?.label}
      refuellingTime={refuellingTime}
      unit={unit}
      minWeight={minWeight}
      loading={loading}
      error={error}
      isPlaceholder={isPlaceholder}
      compact={compact}
    />
  )
}

export default HydrogenLevelFigure
